class MirrorField extends HTMLElement {
	#abort: AbortController | null = null;
	#isDirty = false;

	connectedCallback() {
		this.#abort?.abort();
		this.#abort = new AbortController();
		const { signal } = this.#abort;

		const sourceSelector = this.getAttribute("source");
		const target = this.querySelector("input");
		if (!sourceSelector || !target) return;

		target.addEventListener(
			"input",
			() => {
				this.#isDirty = true;
			},
			{ signal },
		);

		document.addEventListener(
			"keyup",
			(event) => {
				const sourceEl = (event.target as Element).closest<HTMLInputElement>(
					sourceSelector,
				);
				if (!sourceEl) return;
				if (this.#isDirty) return;

				target.value = sourceEl.value
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "")
					.replace(/[^a-zA-Z0-9\s_-]/g, "")
					.trim()
					.replace(/[\s-]+/g, "_")
					.toUpperCase();
			},
			{ signal },
		);
	}

	disconnectedCallback() {
		this.#abort?.abort();
	}
}

if (!customElements.get("mirror-field")) {
	customElements.define("mirror-field", MirrorField);
}
